<template>
    <div class="sidebar">
        <nav class="sidebar-nav">
            <ul class="nav">
                <div v-for="(item, index) in getMenu" :key="index">
                    <router-link :to="item.path">
                        <li class="nav-item">
                            <a class="nav-link">
                                <em class="text-white" :class="item.icon"></em>
                                <span class="ml-2 text-white">{{
                                    item.title
                                }}</span>
                            </a>
                        </li>
                    </router-link>
                </div>
            </ul>
        </nav>

        <!-- <button
            class="sidebar-minimizer brand-minimizer"
            type="button"
        ></button> -->
    </div>
</template>
<script>
export default {
    name: "Sidebar",
    data() {
        return {
            menu: [
                {
                    icon: "icon-speedometer",
                    title: "Dashboard",
                    path: "/admin",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Usuarios",
                    path: "/admin/usuarios",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Concursos",
                    path: "/admin/concursos",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Proyectos",
                    path: "/admin/proyectos",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Categorias",
                    path: "/admin/categorias",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Jurados",
                    path: "/admin/jurados",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Pre-Home",
                    path: "/admin/pre-Home",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Novedades",
                    path: "/admin/novedades",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Terminos",
                    path: "/admin/terminos",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Políticas",
                    path: "/admin/politicas",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Dudas",
                    path: "/admin/dudas",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "T&C - Habeas Data",
                    path: "/admin/t&c",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Historial Usuario",
                    path: "/admin/historial-usuario",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Errores Formulario",
                    path: "/admin/errores-formulario",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Tratamiento Datos",
                    path: "/admin/tratamiento-datos",
                    show: true,
                },
                {
                    icon: "icon-info",
                    title: "Datos Personales y Terceros",
                    path: "/admin/datos-personales-terceros",
                    show: true,
                },
            ],
        };
    },
    computed: {
        getMenu() {
            return this.menu;
        },
    },
};
</script>
